"use client";

import { useReportBoundaryCrash } from "~/hooks/useReportBoundaryCrash";

export default function GlobalError({
    error,
}: {
    error: Error & { digest?: string };
}) {
    useReportBoundaryCrash(error);

    const handleRefresh = () => window.location.reload();

    return (
        <html>
            <body>
                <div className="flex flex-col items-center justify-center min-h-screen font-sans p-5 text-center">
                    <h2 className="text-2xl mb-4">Something went wrong</h2>
                    <p className="text-gray-500 mb-6 max-w-[400px]">
                        A loading error occurred. This usually resolves with a page refresh.
                    </p>
                    <button
                        onClick={handleRefresh}
                        className="px-6 py-3 text-base bg-black text-white border-none rounded-lg cursor-pointer"
                    >
                        Refresh Page
                    </button>
                </div>
            </body>
        </html>
    );
}
